/**
 * @generated SignedSource<<63834a41c3ef9118c958e41c9d9bd30d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDocumentMutationsArchiveMutation$variables = {
  id: string;
};
export type useDocumentMutationsArchiveMutation$data = {
  readonly archiveDocument: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
    }>;
    readonly result: {
      readonly archivedAt: any | null | undefined;
      readonly id: string;
    } | null | undefined;
  };
};
export type useDocumentMutationsArchiveMutation = {
  response: useDocumentMutationsArchiveMutation$data;
  variables: useDocumentMutationsArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ArchiveDocumentResult",
    "kind": "LinkedField",
    "name": "archiveDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDocumentMutationsArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDocumentMutationsArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99313728fbb192c0b506f761c5211fc0",
    "id": null,
    "metadata": {},
    "name": "useDocumentMutationsArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation useDocumentMutationsArchiveMutation(\n  $id: ID!\n) {\n  archiveDocument(id: $id) {\n    errors {\n      code\n      fields\n      message\n      shortMessage\n    }\n    result {\n      id\n      archivedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "543478b92f840081c4e396688d71edab";

export default node;
